// BM-H613 (25 Sep 2026, approved by Vanessa): deferred conflict checks shown
// by age, so they get chased. A deferral counts as cleared for onboarding,
// AML, the FORF and the CCL, so without this list a matter could be fully
// open with its conflict check never run. An open deferral blocks exchange
// (the Pre-Exchange checklist cannot be approved).
import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../config/api";
import { errorMessage } from "../utils/errorMessage";
import { Button } from "./ui/button";

export function ageLabel(days) {
  if (days === null || days === undefined) return "age unknown";
  if (days === 0) return "today";
  if (days === 1) return "1 day";
  return `${days} days`;
}

export default function DeferredConflictChecks({ onComplete }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/conflict-checks/deferred`)
      .then((res) => { if (!cancelled) setRows(res.data?.deferred || []); })
      .catch((err) => {
        if (!cancelled) setError(errorMessage(err, "Could not load the deferred conflict checks"));
      });
    return () => { cancelled = true; };
  }, []);

  if (error) {
    return (
      <div className="mb-4 rounded-md border border-status-red/40 bg-status-red/10 px-4 py-2 text-sm text-status-red"
           role="alert" data-testid="deferred-checks-error">
        {error}
      </div>
    );
  }
  if (!rows || rows.length === 0) return null;

  return (
    <div className="glass-card rounded-md mb-6 border border-amber-500/40" data-testid="deferred-checks-panel">
      <div className="px-5 py-3 border-b border-navy-border/60">
        <h2 className="text-sm font-semibold text-white">
          Deferred conflict checks to complete ({rows.length})
        </h2>
        <p className="text-xs text-txt-muted">
          Oldest first. A deferred check must be completed before exchange.
        </p>
      </div>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-xs text-gray-400">
            <th className="px-5 py-2 font-medium">Waiting</th>
            <th className="px-2 py-2 font-medium">Matter</th>
            <th className="px-2 py-2 font-medium">Client</th>
            <th className="px-2 py-2 font-medium">Fee earner</th>
            <th className="px-2 py-2 font-medium">Why deferred</th>
            <th className="px-5 py-2" />
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t border-white/5" data-testid={`deferred-row-${r.id}`}>
              <td className="px-5 py-2 text-status-amber whitespace-nowrap">{ageLabel(r.age_days)}</td>
              <td className="px-2 py-2 font-mono text-xs text-white">{r.matter_reference}</td>
              <td className="px-2 py-2 text-white">{r.client_name}</td>
              <td className="px-2 py-2 text-gray-400">{r.fee_earner}</td>
              <td className="px-2 py-2 text-gray-400">{r.not_ready_reason || "-"}</td>
              <td className="px-5 py-2 text-right">
                <Button size="sm" className="bg-status-amber hover:bg-status-amber text-black"
                        onClick={() => onComplete(r.id)}
                        data-testid={`deferred-complete-${r.id}`}>
                  Complete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
